import styled from 'styled-components';

import Footer from './Footer';
import Header from './Header';
import HomeSectionImage from './HomeSectionImage';
import Section from './Section';
import Wrapper from './Wrapper';

const RegistrationPage = styled('div')``;

type PageProps = typeof RegistrationPage & {
  Footer: typeof Footer;
  Header: typeof Header;
  HomeSectionImage: typeof HomeSectionImage;
  Section: typeof Section;
  Wrapper: typeof Wrapper;
};

const Page = RegistrationPage as PageProps;

Page.Footer = Footer;
Page.Header = Header;
Page.HomeSectionImage = HomeSectionImage;
Page.Section = Section;
Page.Wrapper = Wrapper;

export default Page;
